import { ReactNode, useMemo } from 'react';
import { AppScopeContext } from './AppScopeContext';
import {
  NOT_INITIALIZED_APP_SCOPE,
  type InternalAppScope
} from './internalAppScope';
import { useOrganizationId } from './useOrganizationId';

export function GlobalAppScopeProvider({ children }: { children: ReactNode }) {
  const organizationId = useOrganizationId();

  const scope = useMemo((): InternalAppScope => {
    if (!organizationId) {
      return NOT_INITIALIZED_APP_SCOPE;
    }
    return { level: 'organization', organizationId };
  }, [organizationId]);

  return (
    <AppScopeContext.Provider value={scope}>
      {children}
    </AppScopeContext.Provider>
  );
}
